<template>
  <custom-callout
    class="mb-3"
    :controlled="false"
    :has-toggle="false"
    :has-border="false"
  >
    <div class="row m-0 d-flex align-items-center py-2">
      <div class="col-md-3 col-12 mb-lg-0 border-right">
        <div class="color-secondary-6 font-14 font-weight-normal">
          Nombre del Material/Equipo:
        </div>
        <div class="color-black font-16 font-weight-normal text-break">
          {{ item.name | empty }}
        </div>
      </div>
      <div class="col-md-3 col-12 mb-lg-0">
        <div class="color-secondary-6 font-14 font-weight-normal">
          Categoría:
        </div>
        <div class="color-black font-16 font-weight-normal text-break">
          {{ item.category.name | empty }}
        </div>
      </div>
      <div class="col-md-3 col-12 mb-lg-0">
        <div class="color-secondary-6 font-14 font-weight-normal">
          Tipo de Salón:
        </div>
        <div class="color-black font-16 font-weight-normal text-break">
          {{ item.saloonType.name | empty }}
        </div>
      </div>
      <div class="col">
        <action-button
          id="btnSelect"
          i="fas fa-times-circle"
          class="float-md-right mr-2"
          variant="outline-danger"
          :disabled="item.disabled"
          @click="remove"
        />
      </div>
    </div>
  </custom-callout>
</template>

<script>
import CustomCallout from 'custom-callout';
import ActionButton from 'ActionButton';

import alertMixin from '@/mixin/alert.mixin';

import inventoryOrderMaterialsAndEquipmentsService from '@/services/api/inventoryOrderMaterialsAndEquipments.api';

export default {
  name: 'ResultRowSelected',
  mixins: [alertMixin],
  components: {
    CustomCallout,
    ActionButton,
  },
  mixins: [alertMixin],
  props: {
    item: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  computed: {
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
  },
  methods: {
    async remove() {
      const confirmed = await this.ShowCancelModal(
        'Atención',
        `¿Está seguro que desea eliminar esta selección?`,
        'Si',
        'No'
      );

      if (!confirmed) return;

      try {
        await inventoryOrderMaterialsAndEquipmentsService.removeOrder(
          this.item.id
        );

        this.ShowToast(
          'Proceso exitoso.',
          'El registro se ha eliminado correctamente.',
          'success'
        );

        this.$emit('removed', this.item);
      } catch (error) {
        this.ShowToast(
          'Error',
          'Ha ocurrido un error al guardar la solicitud.',
          'error'
        );
      }
    },
  },
};
</script>
<style scoped lang="scss">
@use "sass:map";
@import '@/assets/scss/variables/_colors.scss';

::v-deep .ab-btn-success {
  color: map.get($colors, 'white') !important;
  background-color: map.get($colors, 'green') !important;
  border-color: map.get($colors, 'green') !important;
}
::v-deep .text-disabled {
  color: #b5c3bc !important;
}
</style>
